import React from 'react';
// Styles provided by RestaurantOnboarding.css

const RestaurantStepper = ({ currentStep, total }) => {
  const pct     = Math.round((currentStep / (total - 1)) * 100);
  const showPct = currentStep > 0;

  return (
    <div className="ro-prog">
      <div className="ro-prog-track">
        <div
          key={currentStep}
          className="ro-prog-fill ro-prog-fill--pulse"
          style={{ width: `${pct}%` }}
        />
      </div>
      {showPct && (
        <span className="ro-prog-label">{pct}% completado</span>
      )}
    </div>
  );
};

export default RestaurantStepper;
